import {ChangeDetectionStrategy, Component, OnInit, ViewChild} from '@angular/core';
import {ApUsersAssignmentFarmComponent}                        from './assignment/ap-users-assignment-farm.component';
import {ApUsersComponent}                                      from './user/ap-users.component';
import {ApUsersInvitationComponent}                            from './invitation/ap-users-invitation.component';
import {
  ApUsersInvitationEditComponent
}                                                              from '../../../entry-components/ap-basedata-entry-components/ap-users-invitation-edit.component';
import {ApPermissions}                                         from 'invoker-transport';
import {FormStore}                                             from '../../../stores/layout/form.store';
import {MapViewStore}                                          from '../../../stores/layout/mapview.store';
import {
  ApUserContactsOverviewComponent
}                                                              from './user-contacts/ap-user-contacts-overview.component';
import {
  ApUserContactsEditComponent
}                                                              from '../../../entry-components/ap-basedata-entry-components/ap-user-contacts-edit.component';

/**
 * TODO: Meldung Admin Entfernt sich selber
 */

export enum UserTabs {
  User = 0,
  Invitation = 1,
  Contacts = 2
}

@Component({
  selector: 'ap-users-overview',
  templateUrl: 'ap-users-overview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApUsersOverviewComponent implements OnInit {
  @ViewChild(ApUsersComponent, {static: false})
  public usersComponent: ApUsersComponent;

  @ViewChild(ApUsersAssignmentFarmComponent, {static: false})
  public userAssigmentFarmComponent: ApUsersAssignmentFarmComponent;

  @ViewChild(ApUsersInvitationComponent, {static: false})
  public userInvitationComponent: ApUsersInvitationComponent;

  @ViewChild(ApUserContactsOverviewComponent, {static: false})
  public userContactsComponent: ApUserContactsOverviewComponent;

  public showAssigmentTab = false;
  public selectedTab: UserTabs = UserTabs.User;
  public ApPermissions = ApPermissions;

  constructor(private formStore: FormStore,
              private mapViewStore: MapViewStore) {
  }

  ngOnInit(): void {
    this.mapViewStore.hideMapView();
  }

  public selectTab(e: any): void {
    switch (this.selectedTab) {
      case UserTabs.User:
        this.usersComponent?.dynComponent?.dynGrid?.filterGrid('');
        break;
      case UserTabs.Invitation:
        this.userInvitationComponent?.dynComponent?.dynGrid?.filterGrid('');
        break;
      case UserTabs.Contacts:
        this.userContactsComponent?.dynComponent?.dynGrid?.filterGrid('');
        break;
    }
    this.selectedTab = e.index;
  }

  public searchIn(value: string): void {
    switch (this.selectedTab) {
      case UserTabs.User:
        this.usersComponent?.dynComponent?.dynGrid?.filterGrid(value);
        break;
      case UserTabs.Invitation:
        this.userInvitationComponent?.dynComponent?.dynGrid?.filterGrid(value);
        break;
      case UserTabs.Contacts:
        this.userContactsComponent?.dynComponent?.dynGrid?.filterGrid(value);
        break;
    }
  }

  public createNew(): void {
    switch (this.selectedTab) {
      case UserTabs.User:
        this.formStore.openForm({component: ApUsersInvitationEditComponent, data: null});
        return;
      case UserTabs.Invitation:
        this.formStore.openForm({component: ApUsersInvitationEditComponent, data: null});
        return;
      case UserTabs.Contacts:
        this.formStore.openForm({component: ApUserContactsEditComponent, data: null});
        return;
      default:
        return;
    }
  }

  public isCreateNewAllowed(): boolean {
    switch (this.selectedTab) {
      case UserTabs.User:
      case UserTabs.Contacts:
      case UserTabs.Invitation:
        return true;
    }
  }
}
